import { AppComponent } from './../../app.component';
import { AlertPopup, HttpLoader } from './../../app.config';
import { Component, Input, OnInit, Directive } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { config } from '../../app.config';
import { ValidationService } from '../form-validation/validation.service';
import { UserService } from './../userandgroup/user/user.service';
// import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { DataSharingService } from 'app/shared/data-sharing.service';
import { PasswordResetService } from '../password-reset/password-reset.service';
import { LlmService } from 'app/services/llm.service';

// @Directive()
@Component({
    selector: 'app-verify',
    templateUrl: './verification.component.html',
    styleUrls: ['./verification.component.scss'],
    standalone: false
})

export class VerificationComponent implements OnInit {
  verifyForm: FormGroup;
  showVerificationPin = false;

  validErrMsg: string = '';

  hostlogo: any;
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private alert: AlertPopup,
    private httpLoader: HttpLoader,
    private app: AppComponent,
    private dataSharingService: DataSharingService,
    private passwordResetService: PasswordResetService,
    private userService: UserService, private llmService: LlmService) {
    this.verifyForm = formBuilder.group({
      verify_otp: ['', Validators.compose([Validators.required])]
    });
  }

  ngOnInit() {

  }

  returnToLogin() {
    this.router.navigate(['/login']);
  };

  public isNumberOnly(evt: any) {
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      // this.discountValidate = true;
      this.alert.showAlertMessage({ message: 'Please enter 6 digit OTP number only.' });
      // this.priceErrMsg = 'Please enter discount number only. For example 535';
      return false;
    } else {
      // this.discountValidate = false;
      return;
    }
  }

  isvalidateOtp(event:any) {
    let otp = event.target.value;
    if (otp.length == 6) {
      let button:any = document.querySelector('.disabledBtn');
      button.removeAttribute('disabled');
    } else {
      let button:any = document.querySelector('.disabledBtn');
      button.setAttribute('disabled', 'disabled');
    }
  }

  // verifyAcc(formVal:any) {

  //   try {
  //     this.userService.verify_otp(formVal).subscribe((response:any) => {
  //          if(response['success']){
  //           this.passwordResetService.getUserEmailId(response.user['email_id']);
  //           window.sessionStorage.setItem('email_id' , response.user['email_id']);
  //          if(localStorage.getItem("token")){
  //           this.userService.getCurrentUserDetail().subscribe((userResponse:any)=>{
  //             console.log("userResponse",userResponse);
  //             let userDetail=userResponse['userDetail'];
  //             let payLoad ={
  //               "client_id":userDetail['company_id'],
  //               "user_id":userDetail['user_id'],
  //               "email":response.user['email_id'],
  //               "full_name":userDetail['first_name']+" "+userDetail['last_name']
  //             };

  //             this.llmService.llmCreateUser(payLoad).subscribe((llmres:any)=>{

  //             });

  //            });
  //           }
  //           this.router.navigate(['/set_password']);
  //          }

  //      // this.router.navigate(['/set_password'])
  //       // window.localStorage.user_id = JSON.stringify(response['user_id']);
  //       // window.localStorage.user_role = JSON.stringify(parseInt(response['user_role']));
  //       // window.localStorage.token = JSON.stringify(response['token']);

  //       // const isActiveUserRole = parseInt(response['user_role']);

  //       // if(isActiveUserRole===1){
  //       //   this.router.navigate(['/userandgroup/user']);
  //       // }else{
  //       //   this.router.navigate(['/studyroom']);
  //       // }
  //       // // this.router.navigate(['/chats']);

  //       // this.app.getUserStatusData();
  //        // this.app.getCurrentUserData();

  //     }, error => {
  //       this.alert.showAlertMessage(error.error);
  //     });
  //   } catch (err) {

  //   }
  // };


  verifyAcc(formVal: any) {
    try {

      this.httpLoader.showLoader();

      this.showVerificationPin = true;

      this.userService.verify_otp(formVal).subscribe({
        next: (response: any) => {
          // if (!response?.success) return;

          this.httpLoader.hideLoader();

          this.showVerificationPin = false;

          const email = response.user?.email_id;

          // Save email for password reset flow
          this.passwordResetService.getUserEmailId(email);
          sessionStorage.setItem('email_id', email);

          // If token exists, fetch current user & create LLM user
          // if (localStorage.getItem("token")) {
          //   this.userService.getCurrentUserDetail().subscribe({
          //     next: (userResponse: any) => {
          //       const userDetail = userResponse?.userDetail;
          //       if (!userDetail) return;

          //       const payload = {
          //         client_id: userDetail.company_id,
          //         user_id: userDetail.user_id,
          //         email: email,
          //         full_name: `${userDetail.first_name} ${userDetail.last_name}`
          //       };

          //       this.llmService.llmCreateUser(payload).subscribe({
          //         next: () => console.log("LLM user created successfully"),
          //         error: (err) => console.error("LLM create user failed", err)
          //       });
          //     },
          //     error: (err) => console.error("Get current user failed", err)
          //   });
          // }

          // Navigate after success
          this.router.navigate(['/set_password']);
        },

        error: (error) => {
          // this.alert.showAlertMessage(error?.error || "OTP verification failed");
          this.httpLoader.hideLoader();
          this.validErrMsg = error?.error || "OTP verification failed";

          setTimeout(() => {
            this.validErrMsg = ''
          }, 3000);
        }
      });
    } catch (err) {
      console.error("verifyAcc error:", err);

      this.httpLoader.hideLoader();

      this.validErrMsg = "verifyAcc error:", err;

      setTimeout(() => {
        this.validErrMsg = ''
      }, 3000);
    }
  }

  redirectToSignIn(){
    this.router.navigate(['/login']);
  }
}

